import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class UsersService {
  createUser = (fields) => {
    return fetch(config.config.endpointUrls.createUser(), {
      method: 'POST',
      body: fields
    })
  }

  fetchUserDetails = ({ id = '@me', ...params }) => {
    return fetch(config.config.endpointUrls.fetchUserDetails({ id, ...params }), {
      method: 'GET'
    })
  }

  searchUsers = (params) => {
    return fetch(config.config.endpointUrls.searchUsers(), {
      method: 'POST',
      body: params
    })
  }

  updateUser = ({ id, ...fields }) => {
    return fetch(config.config.endpointUrls.updateUser({ id }), {
      method: 'PATCH',
      body: fields
    })
  }

  toggleDeactivateUser = ({ id }) => {
    return fetch(config.config.endpointUrls.toggleDeactivateUser({ id }), {
      method: 'PUT'
    })
  }

  fetchFollowing = () => {
    return fetch(config.config.endpointUrls.fetchFollowing(), {
      method: 'GET'
    })
  }

  setCurrentOrder = ({ currentOrder, ...params }) => {
    return fetch(config.config.endpointUrls.setCurrentOrder(params), {
      method: 'POST',
      body: currentOrder
    })
  }

  getCurrentOrder = (params) => {
    return fetch(config.config.endpointUrls.getCurrentOrder(params), {
      method: 'GET'
    })
  }

  fetchPersonalNotifications = (params) => {
    return fetch(config.config.endpointUrls.fetchPersonalNotifications(params), {
      method: 'GET'
    })
  }

  setNotificationUserStatus = ({ status, ...params }) => {
    return fetch(config.config.endpointUrls.setNotificationUserStatus(params), {
      method: 'PUT',
      body: status
    })
  }

  getTotalNotificationsNotViewed = () => {
    return fetch(config.config.endpointUrls.getTotalNotificationsNotViewed(), {
      method: 'GET'
    })
  }

  fetchCustomerRelationshipsForUser = params => {
    return fetch(config.config.endpointUrls.fetchCustomerRelationshipsForUser(params), {
      method: 'GET'
    })
  }

  setCustomerRelationshipsForUser = ({ userId, ...fields }) => {
    return fetch(config.config.endpointUrls.setCustomerRelationshipsForUser({ userId }), {
      method: 'POST',
      body: fields
    })
  }

  setStoreRelationshipsForUser = ({ userId, ...fields }) => {
    return fetch(config.config.endpointUrls.setStoreRelationshipsForUser({ userId }), {
      method: 'PUT',
      body: fields
    })
  }

  setDepartmentRelationshipsForUser = ({ userId, ...fields }) => {
    return fetch(config.config.endpointUrls.setDepartmentRelationshipsForUser({ userId }), {
      method: 'PUT',
      body: fields
    })
  }
}

export default new UsersService()



// WEBPACK FOOTER //
// ../src/services/usersService/usersService.js